import { Component, Input, SkipSelf, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Context } from 'src/app/model/context';
import { Demande } from 'src/app/model/demande';
import { Upload } from 'src/app/model/upload';
import { PublicService } from 'src/app/services/public.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-finalisation',
  templateUrl: './finalisation.component.html',
  styleUrls: ['./finalisation.component.css'],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]],
  }]
})
export class FinalisationComponent {  
  @Input() demande: Demande;
  @Input() context: Context;
  @Input() form: boolean;
  @Output() onFinish: EventEmitter<any> = new EventEmitter();

  constructor(private publicService: PublicService) { }

  finish() {      
    this.context.sending = true;
    let upload = new Upload();
  
    this.context.cibles.filter(t => t.selected).forEach(t => t.crecheIds.split(',').forEach(id => upload.crecheIds.push(parseInt(id))));
    upload.demande = JSON.parse(JSON.stringify(this.demande));

    if (upload.demande.source && upload.demande.source.toLowerCase() == 'autre' && upload.demande.sourceAutre != '') {
      upload.demande.source = upload.demande.source + ' : ' + upload.demande.sourceAutre;
    }
    delete upload.demande.sourceAutre;

    this.publicService.sendMetric(upload).subscribe();

    this.publicService.sendDemand(upload, this.context).subscribe(() => {
     
      if (this.context.urlRedirection !== null) {
        window.location.href = this.context.urlRedirection;
      } else {
        this.context.sending = false;
        Swal.fire({
          text: 'Votre demande a été transmise !',
          icon: 'success'
        }).then(() => {        
          this.onFinish.emit();
        });    
      }
    }, err => {
      const data = {
        demande: upload,
        error: err
      };

      this.publicService.sendMetric(data).subscribe();
      
      this.context.sending = false;
      Swal.fire({
        text: 'Une erreur est survenue, vérifier votre saisie et ré-essayez ultérieurement !',
        icon: 'error'
      });  
    })
  }

  isHorairesValid(): boolean {
    let tmp = true;
    this.demande.planning.forEach(c => { if (c.debut > c.fin) tmp = false; });        
    return tmp;
  }

  hasSelectedTarget(): boolean {
    let tmp = false || this.context.cibles.length == 0;
    this.context.cibles.forEach(t => tmp = tmp || t.selected);
    return tmp;
  }
}